import "./BranchRiskRowComponent.scss";
import {BranchViewRow} from "../../../models/view-model/RiskDashboardViewModel";
import {RiskDashboardViewStore} from "../../../store/RiskDashboardViewStore";
import {RiskRowEntityType} from "../../../models/RiskRowEntityType";

export const BranchRiskRow = "branchRiskRow";

export function branchRiskRow() {
    return {
        templateUrl: "app/risk/dashboard/components/grid/branch/BranchRiskRowComponent.html",
        bindings: {
            branch: "<",
            viewStore: "<"
        },
        controllerAs: "ctrl",
        controller: BranchRiskRowComponentController
    };
}

export class BranchRiskRowComponentController {
    public readonly branch: BranchViewRow;
    public readonly viewStore: RiskDashboardViewStore;

    public toggleCollapse() {
        this.viewStore.toggleCollapse(RiskRowEntityType.BRANCH, this.branch.entity.id);
    }
}
